export default () => {
    return [
        {
            path: '/planiDesignerPage',
            name: 'planiDesignerPage',
            component: () => import('./views/planiDesignerPage.vue'),
        },
    ];
};
